'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024proto$0024$002dGroup$002dSigning from "./presto.types$proto$-Group-Signing.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$GroupSigning$() {
}
export { $c_Lpresto_types$proto$GroupSigning$ as $c_Lpresto_types$proto$GroupSigning$ };
$p = $c_Lpresto_types$proto$GroupSigning$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$GroupSigning$;
/** @constructor */
function $h_Lpresto_types$proto$GroupSigning$() {
}
export { $h_Lpresto_types$proto$GroupSigning$ as $h_Lpresto_types$proto$GroupSigning$ };
$h_Lpresto_types$proto$GroupSigning$.prototype = $p;
$p.l = (function() {
  return "GroupSigning";
});
$p.cGh = (function(x$0) {
  return new $j_presto$002etypes$0024proto$0024$002dGroup$002dSigning.$c_Lpresto_types$proto$GroupSigning((!(!x$0.j(0))));
});
var $d_Lpresto_types$proto$GroupSigning$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$GroupSigning$, "presto.types$proto$GroupSigning$", ({
  a3E: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$proto$GroupSigning$ as $d_Lpresto_types$proto$GroupSigning$ };
var $n_Lpresto_types$proto$GroupSigning$;
function $m_Lpresto_types$proto$GroupSigning$() {
  if ((!$n_Lpresto_types$proto$GroupSigning$)) {
    $n_Lpresto_types$proto$GroupSigning$ = new $c_Lpresto_types$proto$GroupSigning$();
  }
  return $n_Lpresto_types$proto$GroupSigning$;
}
export { $m_Lpresto_types$proto$GroupSigning$ as $m_Lpresto_types$proto$GroupSigning$ };
//# sourceMappingURL=presto.types$proto$-Group-Signing$.js.map
